<template>
    <v-layout v-if="history.length" row wrap>
        <v-flex class="pr-lg-1" xs12>
            <v-card class="orders_chart elevation-0 mx-3 mt-6 mb-4" color="#fff">
                <div class="order_title ml-8 pt-8" style="font-size: 18px">
                    Payment history account
                </div>
                <template v-if="$vuetify.breakpoint.lgAndUp">
                    <v-row class="chart_header px-5 py-7">
                        <v-col cols="3 text-center">Date</v-col>
                        <v-col cols="2 text-center">Status</v-col>
                        <v-col cols="2 text-center">Amount</v-col>
                        <v-col cols="2 text-center">Method</v-col>
                        <v-col cols="3 text-center">Info</v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <div
                        class="order_item"
                        v-for="(order, index) in history"
                        :key="index"
                    >
                        <v-row class="chart_content px-5 py-4">
                            <v-col cols="3" class="d-flex justify-center align-center flex-column">
<!--                                <template v-if="order.lines.length">-->
<!--                                    <div v-for="(line, key) in order.lines" v-bind:key="key" style="font-size: 13px; font-weight: bold">{{line.description}}</div>-->
<!--                                </template>-->
                                <div style="font-size: 13px">{{ order.created }}</div>
                            </v-col>
                            <v-col cols="2" v-bind:class="order.status === 'succeeded' || order.status === 'success' || order.status === 'paid' ? 'green--text' : 'orange--text'" class="d-flex justify-center align-center" style="font-size: 13px">
                                {{ order.status }}
                            </v-col>
                            <v-col cols="2" class="d-flex justify-center align-center flex-column">
                                <div> ${{order.amount }} ({{order.currency}})</div>
                                <div>
                                    <a href="#" @click.prevent="handleShowInvoice(order.invoice)" v-if="order.invoice">
                                        <span class="blue--text">Get invoice</span>
                                    </a>
                                </div>
                            </v-col>
                            <v-col cols="2" class="d-flex justify-center align-center">
                                {{ order.payment_method_details.type }} ({{order.payment_method_details.brand}} {{order.payment_method_details.card_last_digits}})
                            </v-col>
                            <v-col cols="3" class="text-left" style="font-size: 13px">
                                <div>{{ order.description }}</div>
                                <div v-html="order.metadata"></div>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                    </div>
                </template>
                <template v-else>
                    <div
                        class="order_item"
                        v-for="(order, index) in history"
                        :key="index"
                    >
                        <div class="full_width d-flex flex-column align-center">
                            <div class="full_width px-4 d-flex justify-center mb-4 mt-6">
                                <div class="col py-0 text-start">
                                    <div class="order_title">ID</div>
                                    <div>{{ order.id }}</div>
                                </div>
                            </div>
                            <div class="full_width px-4 d-flex justify-center mb-4">
                                <div class="col py-0 text-start">
                                    <div class="order_title">Date</div>
                                    <div>{{ order.created }}</div>
                                </div>
                            </div>
                            <div class="full_width px-4 d-flex justify-center mb-4">
                                <div class="col py-0 text-start">
                                    <div class="order_title">Status</div>
                                    <div>{{ order.status }}</div>
                                </div>
                            </div>
                            <div class="full_width px-4 d-flex justify-center mb-4">
                                <div class="col py-0 text-start">
                                    <div class="order_title">Amount</div>
                                    <div>{{ order.amount }} ({{order.currency}})</div>
                                    <div>
                                        <a href="#" @click.prevent="handleShowInvoice(order.invoice)" v-if="order.invoice">
                                            <span class="blue--text">Get invoice</span>
                                        </a>
                                    </div>
                                </div>

                            </div>
                            <div class="full_width px-4 d-flex justify-center mb-4">
                                <div class="col py-0 text-start">
                                    <div class="order_title">Method</div>
                                    <div>{{ order.payment_method_details.type }} ({{order.payment_method_details.brand}} {{order.payment_method_details.card_last_digits}})</div>
                                </div>

                            </div>
                            <div class="full_width px-4 d-flex justify-center mb-4">
                                <div class="col py-0 text-start">
                                    <div>{{ order.description }}</div>
                                    <div v-html="order.metadata"></div>
                                </div>

                            </div>
                        </div>
                        <div class="order_divider mt-7"></div>
                    </div>
                </template>
                <v-row
                    @click="loadHistory(current_page + 1)"
                    class="d-flex justify-center py-9"
                    v-if="has_more"
                >
                    <v-btn
                        class="load_btn mt-2"
                        width="189px"
                        height="60px"
                        outlined
                        rounded
                        color="#2C4370"
                    >
                        Load more
                    </v-btn>
                </v-row>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {getInvoiceById} from "@/api/invoice";

export default {
    name: "StripePaymentHistroy",
    data: function() {
        return {
            loading: false
        }
    },
    computed: {
        ...mapGetters('payment', [
            'history',
            'has_more',
            'current_page',
        ]),
    },
    created() {
        this.clearState();
        this.loadHistory();
    },
    methods: {
        ...mapActions('payment', ['getHistory', 'clearState']),

        loadHistory(page = 1) {
            if (this.loading) {
                return;
            }
            this.loading = true;
            this.getHistory(page).then().finally(() => {
                this.loading = false;
            });
        },

        handleShowInvoice(invoice) {
            getInvoiceById(invoice).then(({data: {invoice_pdf_url}}) => {
                if (invoice_pdf_url) {
                    window.open(invoice_pdf_url, '_blank');
                } else {
                    alert('Invoice not found');
                }
            });
        },
    }
}
</script>

<style scoped>
.chart_header {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
}
.chart_content,
.chart_content a {
    color: #fff;
    font-size: 16px;
}
.order_item,
.order_item a {
    color: #fff;
    font-size: 16px;
    line-height: 1.5em;
}
.chart_content a,
.order_item a {
    text-decoration: none;
}

.order_item_cancel .row {
    margin: 0;
}
.order_item_cancel span {
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    color: #582121;
}

.subs_chart_questinon span {
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    color: #582121;
}

.order_title {
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
}
.full_width {
    width: 100%;
}
.order_divider {
    width: 100%;
    height: 1px;
    background-color: #eaeaea;
}
.load_btn {
    text-transform: none;
    font-size: 18px;
}


.orders_chart {
    border-radius: 20px !important;
}
.chart_header {
    font-size: 16px;
    font-weight: bold;
    color: #2c4370;
}
.chart_content,
.chart_content a {
    color: #2c4370;
    font-size: 16px;
}
.order_item,
.order_item a {
    color: #2c4370;
    font-size: -16px;
    line-height: 1.5em;
}
.chart_content a,
.order_item a {
    text-decoration: none;
}

.order_title {
    font-weight: bold;
}
.full_width {
    width: 100%;
}
.order_divider {
    width: 100%;
    height: 1px;
    background-color: #eaeaea;
}
.load_btn {
    text-transform: none;
    font-size: 18px;
}
</style>
